import React from "react";
import { TMap, MultiMarker } from '@map-component/react-tmap';

const Map = ({lat = '', lng = '' , zoom=16}) =>
{
    return (
        <TMap 
            center={{ lat: lat, lng: lng }} 
            mapKey="MMVBZ-UCEKI-DFKGG-UC3DX-7ATT2-R5F3S" zoom={zoom} >
            <MultiMarker
                id="Marker"
                styles={[{
                    "myStyle": {
                        "width": 25,  // 点标记样式宽度（像素）
                        "height": 35, // 点标记样式高度（像素）
                        "src": '../../../img/frame/lose.png',  //图片路径
                        //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                        "anchor": { x: 16, y: 32 }
                    }
                }]
                }
                geometries={
                    [{
                        "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                        "styleId": 'myStyle',  //指定样式id
                        "position": ({ lat: lat, lng: lng })
                    }]
                }
            />
        </TMap>
    )
}

export default Map;